<template>
  <div>
    <modal width='70%' :visible.sync='isShowDialog' append-to-body :closeOnClickModal='false'>
      <div v-if='step === 1'>
        <el-form class='under-line'>
          <el-form-item :label="$t('integration.unit_path')" required>
            <div class='uk-flex'>
              <el-select style='width:250px' v-model='structureText' popper-class='Architecture'>
                <el-option :value='structureText'>
                  <div class='treeClass'>
                    <trees @changeNode='nodeClick' :treedata='treeData' ref='tree' />
                  </div>
                </el-option>
              </el-select>

              <span v-if='!isShowUnitInput' class='under-line ml-10'
                    @click='isShowUnitInput = true'>{{ $t('integration.add_department') }}</span>
              <div v-else class='uk-flex'>
                <span class='ml-10 mr-10'>/</span>
                <el-input style='width:100px;' v-model='dioForm.planName' />
                <i class='iconfont icon-backward ml-10' :title="$t('integration.back')"
                   @click='isShowUnitInput = false'></i>

              </div>
            </div>

          </el-form-item>
        </el-form>

        <div class='uk-flex' style='height: 450px;'>
          <!-- 设备列表 -->
          <div class='w-20 pd-10' style='overflow: auto;'>
            <div v-for='(item,index) in deviceList' :key='index'
                 class='color-white pd-10 mb-10  pr'
                 :class="curDevice && item.deviceId === curDevice.obj.deviceId && item.deviceCatalog === curDevice.obj.deviceCatalog ? 'bg-orange' : 'bg-theme'"
                 @click='changeDevice(item)'>
                <p class='pb-5 font-16'>{{ item.deviceCode }}</p>
                <p>{{ $t('integration.type') }}: {{ $t(equiIconConvert(item.deviceCatalog, item.deviceType).title) }}</p>
                <i v-if="item.isPos" class="el-icon-delete related-icon" @click.stop="handleDeviceDel(item)" style="font-size: 35px;color: #fff"></i>
            </div>
          </div>
          <!-- 平面图 -->
          <div class='bd-l pd-10 pr' style='width:80%;'>

            <i v-if='isShowFirstAddIcon' class='el-icon-plus position-center cursor-pointer ' style='font-size: 60px;'
               @click='isShowUpload = true'></i>

            <div v-else class='upload-icon pd-5 bg-white border-theme' @click='isShowUpload = true'>
              <i class='el-icon-upload font-24'></i>
            </div>

            <div v-if='isShowUpload' class='uk-flex upload-div position-center bg-white border-theme pd-10 '>
              <el-input :placeholder="$t('integration.please_upload_the_plan')"
                        disabled
                        v-model='dioForm.base64'
                        style='width:200px;'>
              </el-input>
              <el-upload
                class='upload-demo'
                ref='upload'
                action='https://'
                :http-request='
                    file => {
                        uploadFile(file);
                    }
                '
                :on-remove='handleRemove'
                :show-file-list='false'
                :on-change='onChange'
                accept='.jpg, .png, .JPG, .PNG'
                :before-upload='beforeUpload'
                :file-list='fileList'
                :auto-upload='false'
              >
                <el-button type='primary' slot='trigger'>{{ $t('integration.browser') }}</el-button>
                <el-button type='primary' :disabled='!dioForm.base64' @click='submitUpload'>{{ $t('public.save') }}
                </el-button>
              </el-upload>

              <i class='el-icon-circle-close color-red font-24'
                 style='position: absolute;right: -15px; top: -15px;'
                 @click='isShowUpload = false'></i>
            </div>

            <PlaneCanvas v-show='pmObj && pmObj.base64Path' :pmObj='pmObj' :newInfo='curDevice'
                         @xyPosFn='xyPosFn'></PlaneCanvas>

          </div>
        </div>
      </div>

      <CarrierForm v-else></CarrierForm>

      <div slot='footer' class='uk-flex uk-flex-between ml-10'>
        <el-button type='danger' @click='isShowDialog = false'
        >{{ $t('buttonTitle.Cancel') }}
        </el-button>
        <div>
          <el-button v-if='step === 1'
                     type='primary' @click='handleSavePosition'
          >{{ $t('buttonTitle.Next Step') }}
          </el-button>
          <el-button v-else
                     type='primary' @click='step = step-1'
          >{{ $t('buttonTitle.Previous Step') }}
          </el-button>
          <el-button el-button type='primary' @click='isShowDialog = false'
          >{{ $t('guideText.Complete') }}
          </el-button>
        </div>

      </div>
    </modal>
  </div>
</template>
<script>
import CarrierForm from './carrierFrom.vue'
import { saveScenePlane, getScenePlaneDevice, getUnBindDevice, saveScenePlaneDevice } from '@/api/api'
import { shareTree } from '@/api/modules/public'
import StatisticObject from '@/pages/count/statistic/component/StatisticObject/StatisticObject.vue'
import resultHandle from '@/common/resultHandle'
import { equiIconConvert } from '@/utils/convert'
import PlaneCanvas from './PlaneCanvas.vue'
import bus from '@/utils/bus.js'
import { sceneGetPlanDetail, getBindDevicePosition,saveDevicePosition,deleteDevicePosition } from '@/api/modules/architecture.js'
import { handlePlanData, PLAN_INFO_TYPE } from '@/utils/planUtil-mf'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }

  },
  components: {
    CarrierForm,
    StatisticObject,
    PlaneCanvas
  },
  data () {
    return {
      equiIconConvert,
      deviceScene: [],
      scopeId: null,
      dioForm: {
        sceneId: '',
        base64: '',
        nodeId: '',
        planName: '',
        parentCode: '',
        uploadFile: null
      },
      selectNode: null,// 当前选择的节点，用于后面做判断
      fileList: [],
      pointList: [],

      planId: '', // 平面图id
      curDevice: null, // 当前选择的正在描点的设备

      isShowUpload: false,
      isShowUnitInput: false,
      step: 1,
      treeData: [],
      structureText: '',

      // xyPosList: [],

      isShowFirstAddIcon: true,  //一开始显示中间的+上传按钮，当有图片时就不显示中间的+，显示右上角的上传图标
      pmObj: {}, // 平面图数据
      existPmObj: {} // 将接口获取到已有的平面信息先保存

    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val)
      }
    },
    deviceList() {
      return this.deviceScene.map(item => {
          return {
            isPos: this.pointList?.some(item1 => item1.id === item.deviceId + '-' + item.deviceCatalog),
            ...item
          }
        }
      )
    },
  },
  mounted () {
    this.getTree()
    this.getDevices({})

    bus.$on('delPosition', info => {
        this.handleDeviceDel(info.obj)
    });
  },

  methods: {
    // 获取组织架构
    getTree () {
      shareTree({
        isEdit: 0,
        all: true
      }).then(({ result }) => {
        this.treeData = (result && result.item) || []
        this.treeData = this.treeData.filter(item => {
          return item.sceneCode !== 'all_node'
        })
      })
    },
    // 获取左边设备列表
    getDevices (params) {
      getUnBindDevice(params).then(res => {
        this.deviceScene = res.result || []
      })
    },
    // 点击组织架构回调
    async nodeClick ({ label }) {
      console.log('label==点击组织架构回调=', label)
      // this.dioForm.nodeId = label.id;
      // this.dioForm.parentCode = label.parent_code;
      this.dioForm.nodeId = label.scene_id ? label.scene_id : label.scopeId
      this.dioForm.sceneId = label.scene_id ? label.scene_id : label.scopeId
      this.dioForm.parentCode = label.level !== 1 ? label.parent_code : label.scene_code
      this.treeData.forEach(item => {
        if (item['scopeId'] === label.scopeId) {
          this.structureText = label.level !== 0 ? item.label + '-' + label.label : label.label
        }
      })
      this.selectNode = label

      // 切换了客户需要重新获取设备列表
      if (this.scopeId == null || this.scopeId != label.scopeId) {
        this.scopeId = label.scopeId
        this.getDevices({ sceneId: this.scene_id })
      }

      // 如果点击的是已有的平面图机构，要获取已有的平面图信息展示
      if (label.funcType != 0) {
        this.curDevice = null
        await this.getPmInfo(label.scene_id)
      } else {
        this.pmObj = {}
        this.isShowFirstAddIcon = true
        this.pointList = []
        this.pmObj.positionList = []
        this.planId = ''
      }
    },

    async getPmInfo (sceneId) {
      let res = await sceneGetPlanDetail({ sceneId: sceneId })
      if (res.result) {
        this.existPmObj = res.result
        // 获取绑定的设备
        if (res.result.planId != undefined) {
          this.planId = res.result.planId
          const res1 = await getBindDevicePosition(this.existPmObj.planId)
          this.pmObj = res.result
          this.pointList =res1.result.map(item => handlePlanData(item, PLAN_INFO_TYPE.DEVICE))
          this.pmObj.positionList = this.pointList
        } else {
          this.planId = ''
        }
        this.isShowFirstAddIcon = false
      } else {
        this.pmObj = {}
        this.isShowFirstAddIcon = true
      }
    },

    handleRemove (file, fileList) {
      this.dioForm.base64 = ''
    },

    onChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.dioForm.base64 = fileList[0].name
    },
    beforeUpload (file) {
      console.log('file=', file)
      const types = ['image/jpg', 'image/png', 'image/JPG', 'image/PNG', 'image/jpeg']
      const isImage = types.includes(file.type)
      const isLtSize = file.size / 1024 / 1024 < 20
      if (!isImage) {
        this.$message.error($t('public.upload_img_tips1'))
        return false
      }
      if (!isLtSize) {
        this.$message.error($t('public.upload_img_tips2'))
        return false
      }
      return true
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    uploadFile (content) {
      let base64
      this.getBase64(content.file).then(res => {
        base64 = res
      })
      const fd = new FormData()
      fd.append('uploadFile', content.file)
      fd.append('nodeId', this.dioForm.nodeId)
      if (this.dioForm.planName == null || this.dioForm.planName == '') {
        fd.append('sceneId', this.dioForm.sceneId)
      }
      fd.append('parentCode', this.dioForm.parentCode)
      fd.append('planName', this.dioForm.planName)
      saveScenePlane(fd).then(async ({
        result,
        state
      }) => {
        await resultHandle(state)
        // 回显
        this.isShowUpload = false
        this.isShowFirstAddIcon = false
        this.planId = result.planId
        this.pmObj = result
        this.pmObj.base64Path = result.path
        this.pmObj.positionList = []
        this.pointList = []
        this.isShowUnitInput = false
        this.curDevice = null

        if (this.dioForm.planName !== ''){
          this.getTree()
        }

        this.dioForm.planName = ''
        this.getDevices({ sceneId: this.scopeId })
      })
        .finally(() => {
        })
    },
    // 上传开始
    submitUpload () {
      if (!this.selectNode) {
        this.$message.error($t('integration.please_select_unit_path'))
        return
      }
      // 判断所选择的机构是否有子节点，没有子节点不能提交，例如，刚注册的客户只有公司名称，没有子节点
      if ((this.selectNode.funcType !== 1 && this.selectNode.item && this.selectNode.item.length === 0) && !this.dioForm.planName) {
        this.$message.error($t('integration.please_add_a_department'))
        return
      }
      this.$confirm($t('integration.this_operation_will_remove_all_monitoring_point_anchors_dot__are_you_sure_this_operation_q'))
        .then(() => {
          this.$refs.upload.submit()
          this.pointList = []

          bus.$emit('updatePmObjPoint', [])
        })
        .catch(() => {
        })
    },
    // 选择设备进行描点
    changeDevice (item) {
      if (!this.planId) {
        this.$message.error($t('integration.please_add_plan_image'))
        return
      }
      this.curDevice = handlePlanData(item, PLAN_INFO_TYPE.DEVICE)

    },
    // 记录下描点的数据
    xyPosFn (obj) {
      console.log('xyPosFn obj -> ',obj)
      if (!obj.xpos || !obj.ypos) return this.$message.warning($t('integration.position_cannot_be_empty'));
      const query = {
        scene_plan_id: this.planId,
        deviceCatalog: obj.obj.deviceCatalog,
        deviceId: obj.obj.deviceId,
        xpos: obj.xpos,
        ypos: obj.ypos
      };
      saveDevicePosition(query).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.successful_positioning'));

          const idx =  this.pointList.findIndex(item => item.id === obj.id)
          if (idx !== -1) {
            this.pointList[idx] = obj
          }else {
            this.pointList.push(obj)
          }
          console.log('xyPosFn idx -> ',idx)
          bus.$emit('updatePmObjPoint', this.pointList);
          bus.$emit('refreshPoint', this.pointList || []);
        } else {
          this.$message.error(state.msg);
        }
      });
    },
    // 保存定位（全部设备定位后一起保存）
    handleSavePosition () {
      this.step += 1
      this.curDevice = null
    },

    handleDeviceDel(val) {
      console.log("handleDeviceDel val ->",val)
      const query = {
        planeId: this.planId,
        deviceCatalog: val.deviceCatalog,
        deviceId: val.deviceId
      };
      this.$confirm(this.$t('public.tip_confirm'))
        .then(() => {
          deleteDevicePosition(query).then(({ result, state }) => {
            if (result && state.code === 200) {
              this.$message.success($t('integration.successfully_deleted'));
              console.log("handleDeviceDel pointList 1 ->",this.pointList)

              this.pointList = this.pointList.filter(item => item.id !== val.deviceId + '-' + val.deviceCatalog);

              console.log("handleDeviceDel pointList 2 ->",this.pointList)

              bus.$emit('updatePmObjPoint', this.pointList);
              bus.$emit('refreshPoint', this.pointList || []);

              this.curDevice = null

            } else if (!result && state.code === 200) {
              // 暂无可移除的监测点锚点
              this.$message.warning($t('integration.there_are_no_removable_mounting_anchors'));
            } else {
              this.$message.error(state.msg);
            }
          });
        })
        .catch(() => {});
    },
  }
}
</script>
<style lang='scss' scoped>
.upload-div {
  background: #fff;

}

.related-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  color: green;
}

.under-line {
  color: #344962;
  border-bottom: 1px solid #344962;
  cursor: pointer;
}

.upload-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 50%;
  // background-color: rgba($color: #fff, $alpha: 0.2);
}

.treeClass {
  height: 100%;
  overflow: auto;

  .el-tree {
    height: 100%;
  }
}

</style>
